export class UsuarioDetalhes{
  nome: string;
  email: string;
  senha: string;
  confirmacaoSenha: string;
  id: number;
  tipoUsuario: number;
  ativo: boolean;
  dataCadastro: Date;
  dataModificacao: Date;
  bloqueio: boolean;
}
